import type { Group } from '@/types'
import { hasExtension } from '@/utils'

export function renderGroups() {
  const groups: Group[] = [
    {
      name: 'format',
      title: 'Format',
      commands: [
        {
          name: 'paragraph',
          label: 'Paragraph',
          aliases: ['paragraph', 'zw'],
          iconName: 'Paragraph',
          shouldBeHidden: editor => !hasExtension(editor, 'heading'),
          action: ({ editor, range }) => {
            editor.chain().focus().deleteRange(range).setParagraph().run()
          },
        },
        {
          name: 'heading1',
          label: 'Heading 1',
          aliases: ['h1', 'bt', 'bt1'],
          iconName: 'Heading1',
          shouldBeHidden: editor => !hasExtension(editor, 'heading'),
          action: ({ editor, range }) => {
            editor.chain().focus().deleteRange(range).setHeading({ level: 1 }).run()
          },
        },
        {
          name: 'heading2',
          label: 'Heading 2',
          aliases: ['h2', 'bt', 'bt2'],
          iconName: 'Heading2',
          shouldBeHidden: editor => !hasExtension(editor, 'heading'),
          action: ({ editor, range }) => {
            editor.chain().focus().deleteRange(range).setNode('heading', { level: 2 }).run()
          },
        },
        {
          name: 'heading3',
          label: 'Heading3',
          aliases: ['h3', 'bt', 'bt3', 'heading3'],
          iconName: 'Heading3',
          shouldBeHidden: editor => !hasExtension(editor, 'heading'),
          action: ({ editor, range }) => {
            editor.chain().focus().deleteRange(range).setNode('heading', { level: 3 }).run()
          },
        },
        {
          name: 'bulletList',
          label: 'Bullet List',
          aliases: ['ul', 'yxlb', 'bulletList'],
          iconName: 'List',
          shouldBeHidden: editor => !hasExtension(editor, 'bulletList'),
          action: ({ editor, range }) => {
            editor.chain().focus().deleteRange(range).toggleBulletList().run()
          },
        },
        {
          name: 'numberedList',
          label: 'Ordered List',
          aliases: ['ol', 'yxlb'],
          iconName: 'ListOrdered',
          shouldBeHidden: editor => !hasExtension(editor, 'orderedList'),
          action: ({ editor, range }) => {
            editor.chain().focus().deleteRange(range).toggleOrderedList().run()
          },
        },
        {
          name: 'blockquote',
          label: 'Blockquote',
          description: 'Insert Blockquote',
          aliases: ['yr'],
          iconName: 'TextQuote',
          shouldBeHidden: editor => !hasExtension(editor, 'blockquote'),
          action: ({ editor, range }) => {
            editor.chain().focus().deleteRange(range).setBlockquote().run()
          },
        },
        {
          name: 'horizontalrule',
          label: 'Horizontal Rule',
          aliases: ['fgx', 'horizontalRule'],
          iconName: 'Minus',
          shouldBeHidden: editor => !hasExtension(editor, 'horizontalRule'),
          action: ({ editor, range }) => {
            editor.chain().focus().deleteRange(range).setHorizontalRule().run()
          },
        },
        {
          name: 'link',
          label: 'Link',
          aliases: ['link', 'lianjie', 'lj'],
          iconName: 'Link',
          shouldBeHidden: editor => !hasExtension(editor, 'link'),
          action: ({ editor, range }) => {
            editor
              .chain()
              .deleteRange(range)
              .extendMarkRange('link')
              .insertContent({
                type: 'text',
                text: 'link',
                marks: [
                  {
                    type: 'link',
                    attrs: {
                      href: '',
                      target: '_blank',
                    },
                  },
                ],
              })
              .setLink({ href: '' })
              .focus()
              .run()
          },
        },
      ],
    },
    {
      name: 'dynamicConstructs',
      title: 'Dynamic Constructs',
      commands: [
        {
          name: 'dynamicVariable',
          label: 'Variable',
          iconName: 'Variable',
          description: 'Insert a dynamic variable',
          aliases: ['dynamicVariable', 'variable'],
          shouldBeHidden: editor => !hasExtension(editor, 'variableNode'),
          action: ({ editor, range }) => {
            editor.chain().focus().deleteRange(range).run()
            editor.commands.openVariableDialog()
          },
        },
        {
          name: 'dynamicIfBlock',
          label: 'If Block',
          iconName: 'If',
          description: 'Insert a dynamic if block',
          aliases: ['dynamicIfCondition', 'if'],
          shouldBeHidden: editor => !hasExtension(editor, 'ifBlock'),
          action: ({ editor, range }) => {
            editor.chain().focus().deleteRange(range).run()
            editor.commands.openIfBlockDialog()
          },
        },
        {
          name: 'dynamicLoopBlock',
          label: 'Loop Block',
          iconName: 'For',
          description: 'Insert a dynamic loop block',
          aliases: ['dynamicLoop', 'loop'],
          shouldBeHidden: editor => !hasExtension(editor, 'forBlock'),
          action: ({ editor, range }) => {
            editor.chain().focus().deleteRange(range).run()
            editor.commands.openForBlockDialog()
          },
        },
      ],
    },
    {
      name: 'insert',
      title: 'Insert',
      commands: [
        {
          name: 'image',
          label: 'Image',
          iconName: 'ImageUp',
          description: 'Insert a image',
          aliases: ['image', 'tp', 'tupian'],
          shouldBeHidden: editor => !hasExtension(editor, 'image') || editor.isActive('columns'),
          action: ({ editor, range }) => {
            editor.chain().focus().deleteRange(range).setImageUpload().run()
          },
        },
        {
          name: 'columns',
          label: 'Two Columns',
          iconName: 'Columns2',
          description: 'Add two column content',
          aliases: ['columns', 'cols', '2cols'],
          shouldBeHidden: editor => !hasExtension(editor, 'columns') || editor.isActive('columns'),
          action: ({ editor, range }) => {
            editor
              .chain()
              .deleteRange(range)
              .setColumns()
              .focus(editor.state.selection.head - 1)
              .run()
          },
        },
      ],
    },
  ]

  return groups
}
